<template>
  <div class="dvHeader">

    <div class="dvModals">

      <div id="modal-set-password" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Set Your Password
          </div>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Current Password</label>
                <input v-model="user.current_password" class="browser-default defaultModal-input" placeholder="Enter your current password" type="password" autocomplete="off"/>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">PLEASE CREATE A NEW PASSWORD</label>
                <input v-model="user.new_password" class="browser-default defaultModal-input" placeholder="Enter your password" type="password" autocomplete="off"/>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <input v-model="user.confirm_new_password" class="browser-default defaultModal-input" placeholder="Re-enter your password" type="password" autocomplete="off"/>
                <div class="defaultModal-helper-text">
                  * Minimum of 6 characters, with at least 1 number and 1 symbol
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">

          <a
            href="javascript:void(0)"
            @click="setYourPassword()"
            :class="{ disabled: updateUserDetails }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check" v-if="!updateUserDetails"></span>
            {{ updateUserDetails ? 'Please wait...' : '' }}
            {{ !updateUserDetails ? 'Save' : '' }}
          </a>

        </div>
      </div><!-- modal-->


      <div id="modal-change-password" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Account Settings
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="#!"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s6 l6 dvModalContent-field">
                <label class="defaultModal-label">First Name</label>
                <input v-model="user.first_name" class="browser-default defaultModal-input" placeholder="Enter your first name" required type="text" />
              </div>
              <div class="col s6 l6 dvModalContent-field">
                <label class="defaultModal-label">Last Name</label>
                <input v-model="user.last_name" class="browser-default defaultModal-input" placeholder="Enter your last name" required type="text" />
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Current Password</label>
                <input v-model="user.current_password" class="browser-default defaultModal-input" placeholder="Enter your current password" type="password" autocomplete="off"/>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Change Password (Optional)</label>
                <input v-model="user.new_password" class="browser-default defaultModal-input" placeholder="Enter your new password" type="password" autocomplete="off"/>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <input v-model="user.confirm_new_password" class="browser-default defaultModal-input" placeholder="Re-enter your new password" type="password" autocomplete="off"/>
                <div class="defaultModal-helper-text">
                  * Minimum of 6 characters, with at least 1 number and 1 symbol
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            href="javascript:void(0)"
            @click="changePassword()"
            :class="{ disabled: updateUserDetails }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check" v-if="!updateUserDetails"></span>
            {{ updateUserDetails ? 'Please wait...' : '' }}
            {{ !updateUserDetails ? 'Save' : '' }}
          </a>
          <a href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>

        </div>
      </div><!-- modal-->

      <div id="modal-update-details" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Update Your Details
          </div>
          <!-- <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" @click="signout()" href="javascript:void(0)"><span class="icon-action_cancel"></span></a> -->
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s6 l6 dvModalContent-field">
                <label class="defaultModal-label">First Name</label>
                <input v-model="user.first_name" class="browser-default defaultModal-input" placeholder="Enter your first name" required type="text" />
              </div>
              <div class="col s6 l6 dvModalContent-field">
                <label class="defaultModal-label">Last Name</label>
                <input v-model="user.last_name" class="browser-default defaultModal-input" placeholder="Enter your last name" required type="text" />
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Current Password</label>
                <input v-model="user.current_password" class="browser-default defaultModal-input" placeholder="Enter your current password" type="password" autocomplete="off"/>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">PLEASE CREATE A NEW PASSWORD</label>
                <input v-model="user.new_password" class="browser-default defaultModal-input" placeholder="Enter your new password" type="password" autocomplete="off"/>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <input v-model="user.confirm_new_password" class="browser-default defaultModal-input" placeholder="Re-enter your new password" type="password" autocomplete="off"/>
                <div class="defaultModal-helper-text">
                  * Minimum of 6 characters, with at least 1 number and 1 symbol
                </div>
              </div>
            </div>

          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">

          <a
            href="javascript:void(0)"
            @click="updateUser()"
            :class="{ disabled: updateUserDetails }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check" v-if="!updateUserDetails"></span>
            {{ updateUserDetails ? 'Please wait...' : '' }}
            {{ !updateUserDetails ? 'Save' : '' }}
          </a>

          <a @click="signout()" href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Logout</a>
        </div>
      </div><!-- modal-->



      <div id="modal-import-referrals" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Import
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="#!"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label"><i class="material-icons">attach_file</i>Upload File</label>
                <input v-show="false" type="file" id="referralfile" ref="referralfile" v-on:change="onChangeFileUpload()" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xls"/>
                <input
                  :disabled="importing"
                  @click="clickFile()"
                  readonly
                  class="defaultModal-input" v-model="importFileName" placeholder="Click here to select excel template (.xls)" type="text" />
                <div class="defaultModal-helper-text">
                  <strong>NOTE: </strong>For importing file, it is required to use the excel template below.<br />
                  <a
                    href="/Seller-Import-Template-formatted.xls"
                    target="_blank">Download Excel Template</a>
                </div>
              </div>
            </div>
            
            <DataPrivacyConsent :dataPrivacy="dataPrivacy"></DataPrivacyConsent>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">

          <a
            v-if="!importing"
            @click="doImportReferralData()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Upload
          </a>

          <a
            v-if="importing"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Uploading...
          </a>

          <a
            :disabled="importing"
            @click="closeModal('modal-import-referrals')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->




    </div>

    <!-- Overlay Menu -->
    <!-- active link add menuItemActive, menuFxActive -->
    <div class="dvOverlayMenu-wrap">
      <div class="dvOverlayMenu">
        <div class="dvOverlayMenu-content" v-if="$getConstRole('ROLE_SUB_ADMIN') != currentUserRole">
          <div class="dvOverlayMenu-primary">
            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'dashboard' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-fs_dashboard"></span>Dashboard
              </router-link>
            </div>
            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'referrals' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-fs_referrals"></span>Referrals
              </router-link>
            </div>
            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'teams' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-fs_teams"></span>Teams
              </router-link>
            </div>
            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'reports' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-fs_reports"></span>Reports
              </router-link>
            </div>
          </div>

          <div class="dvOverlayMenu-secondary">
            <a href="/terms-of-use">Terms of Use</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/contact-us">Contact</a>
          </div>
        </div>

        <div class="dvOverlayMenu-content" v-if="$getConstRole('ROLE_SUB_ADMIN') == currentUserRole">
          <div class="dvOverlayMenu-primary">

            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'admin_channels' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-fs_world"></span>Channels
              </router-link>
            </div>
            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'admin_referrals' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-fs_referrals"></span>Referrals
              </router-link>
            </div>
            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'reports' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-fs_reports"></span>Reports
              </router-link>
            </div>
            <div class="dvOverlayMenu-item-group">
              <router-link class="dvOverlayMenu-item" :to="{ name:'my_activity' }" active-class="menuItemActive">
                <div class="dvOverlayMenuItemFx"></div>
                <span class="icon-editor_list"></span>My Activity
              </router-link>
            </div>
          </div>

          <div class="dvOverlayMenu-secondary">
            <a href="/terms-of-use">Terms of Use</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/contact-us">Contact</a>
          </div>
        </div>

      </div>
    </div>

    <div class="dvHeader-top">
      <!-- Responsive Menu -->
      <div class="dvHeader-top-responsive">
          <div class="dvHamburger-wrap" @click="showMobileNav()">
            <div class="dvHamburger hamburger--spin">
              <div class="hamburger-box">
                <div class="hamburger-inner"></div>
              </div>
            </div>
          </div>
          <a href="javascript:void(0)" @click="gotoMain()" class="dvHeader-logo"><img src="@/assets/svg/alisi-firststep-logo.svg"/></a>
      </div>
      <!-- Responsive Menu end -->

      <div v-if="$getConstRole('ROLE_SUB_ADMIN') != currentUserRole"  class="dvHeader-menu hide-on-small-only">
        <div class="dvHeader-menu-fx"></div>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'dashboard' }" active-class="isActive">
          <span class="icon-fs_dashboard"></span>Dashboard
        </router-link>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'referrals' }" active-class="isActive">
          <span class="icon-fs_referrals"></span>Referrals
        </router-link>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'teams' }" active-class="isActive">
          <span class="icon-fs_teams"></span>Teams
        </router-link>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'reports' }" active-class="isActive">
          <span class="icon-fs_reports"></span>Reports
        </router-link>
      </div> <!-- dvHeader-menu -->

      <div v-if="$getConstRole('ROLE_SUB_ADMIN') == currentUserRole"  class="dvHeader-menu hide-on-med-and-down">
        <div class="dvHeader-menu-fx"></div>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'admin_channels' }" active-class="isActive">
          <span class="icon-fs_world"></span>Channels
        </router-link>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'admin_referrals' }" active-class="isActive">
          <span class="icon-fs_referrals"></span>Referrals
        </router-link>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'reports' }" active-class="isActive">
          <span class="icon-fs_reports"></span>Reports
        </router-link>

        <router-link class="dvHeader-menu-item valign-wrapper" :to="{ name:'my_activity' }" active-class="isActive">
          <span class="icon-editor_list"></span>My Activity
        </router-link>


      </div> <!-- dvHeader-menu -->
      <div
        ref="tippy_settings"
        name="settings-menu"
        class="dvHeader-login">

        <a>
          <div class="dvHeader-login-info">
            {{ username }}
            <div v-if="$getConstRole('ROLE_MANAGER') == currentUserRole || $getConstRole('ROLE_SUB_ADMIN') == currentUserRole" class="dvHeader-login-info-label">{{ currentUserPosition }}</div>
            <div v-if="$getConstRole('ROLE_SUB_ADMIN') == currentUserRole" class="dvHeader-login-info-label">{{ 'Admin' }}</div>
          </div>
          <span class="icon-nav_chevron-down"></span>
        </a>
      </div>
    </div>  <!-- dvHeader-top -->

    <div class="dvHeader-search valign-wrapper">
      <span class="icon-fs_search"></span>
      <label class="hide-on-small-only">Search</label>
      <input type="text" class="browser-default" v-model="q" v-on:keyup.enter="search()" placeholder="Enter keywords (e.g. Client name, location, project)" />
    </div> <!-- dvHeader-top -->

    <tippy
     to="settings-menu"
     placement="bottom"
     offset="[0, 10]"
     interactive
     trigger="click"
     hideOnClick="true"
     theme="light-border"
     arrow="false">
     <div class="userPopMenuBox-content ">

       <router-link
        v-if="$getConstRole('ROLE_SUB_ADMIN') == currentUserRole"
        class="userPopMenuBox-content-item" :to="{ name:'admin_channels' }">
         <span class="icon-fs_world"></span>Channels
       </router-link>

       <router-link
        v-if="$getConstRole('ROLE_SUB_ADMIN') == currentUserRole"
        class="userPopMenuBox-content-item" :to="{ name:'referrals' }">
         <span class="icon-fs_referrals"></span>Referrals
       </router-link>

       <router-link
        v-if="$getConstRole('ROLE_SUB_ADMIN') == currentUserRole"
        class="userPopMenuBox-content-item" :to="{ name:'reports' }">
         <span class="icon-fs_reports"></span>Reports
       </router-link>

       <router-link class="userPopMenuBox-content-item" :to="{ name:'my_activity' }">
         <span class="icon-editor_list"></span>My Activity
       </router-link>

       <a
        v-if="$getConstRole('ROLE_SUB_ADMIN') != currentUserRole"
        @click="showModal('modal-import-referrals')"
        href="javascript:void(0)" class="userPopMenuBox-content-item">
         <span class="icon-nav_arrow_up"></span>Import
       </a>

       <a
        @click="showModal('modal-change-password')"
        href="javascript:void(0)" class="userPopMenuBox-content-item">
         <span class="icon-fs_user"></span>Account Settings
       </a>

       <a
        @click="signout()"
        href="javascript:void(0)" class="userPopMenuBox-content-item">
         <span class="icon-action_logoff"></span>Logout
       </a>
     </div>
   </tippy>

   <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </div> <!-- dvHeader -->
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import M from 'materialize-css'
  import { mapGetters } from "vuex";
  import DataPrivacyConsent from '@/components/DataPrivacyConsent.vue'
  // import { mapState } from 'vuex';

  export default {
    name: 'page-nav',
    data: () => ({
      dataPrivacy: {
        isAgree: false,
        isAgreeDisabled: false
      },
      user: {
        first_name: '',
        last_name: '',
        current_password: '',
        new_password: '',
        confirm_new_password: ''
      },
      userPass: {
        current_password: '',
        new_password: '',
        confirm_new_password: ''
      },
      q: '',
      setPassword: false,
      updateUserDetails: false,
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      username: '',
      currentUserRole: '',
      currentUserPosition: '',
      referralfile: '',
      importing: false,
      importFileName: ''
    }),
    watch:{
      currentUser (){

      },
      $route (to, from){

        this.checkUpdateDetails()
        this.checkSetPassword()

        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        let self = this

        this.$jQuery('.dvHamburger').removeClass('is-active')
        this.$jQuery('.dvOverlayMenu').removeClass('ov-active')
        this.$jQuery('.htmlOverflow').removeClass('hide-overflow')

        if(this.$route.name == 'signin' || this.$route.name == 'search_results'){
          self.$jQuery(".dvHeader-menu-fx").css("display", 'none');
          return
        }

        this.q = ''

        // this.showMobileNav()





        // this.manageNav()

        // self.$jQuery(".dvHeader-menu-fx").css("display", 'none');
        // self.$jQuery(".dvHeader-menu-fx").css("width", 0);

        setTimeout(function(){
          let menuNav = self.$jQuery(".dvHeader-menu-fx");
          // self.$jQuery('.dvOverlayMenuItemFx').removeClass('menuFxActive')
          // let activeMenu = self.$jQuery(".menuItemActive");
          // let dvOverlayMenuItemFx = self.$jQuery(activeMenu).find('.dvOverlayMenuItemFx');
          // self.$jQuery(dvOverlayMenuItemFx).addClass('menuFxActive')
          // self.$jQuery(dvOverlayMenuItemFx).css('width', 0)
          //
          // let menuFxActive = document.querySelector(".menuFxActive")
          //
          // self.$jQuery(menuFxActive).animate(
          //   {
          //     width: '100%'
          //   }
          // );

          // menuFxActive.classList.toggle("animateFx");
          // console.log(activeMenu)

          //

          // if(to.name == 'my_activity'){
          //   self.$jQuery(menuNav).hide()
          //   return
          // }

          if(!menuNav){
            return
          }

          self.$jQuery(".dvHeader-menu-fx").css("display", 'block');
          var calcMenuUIWidth = self.$jQuery(".dvHeader-menu-item.isActive").innerWidth();
          var calcMenuUIPos = self.$jQuery(".dvHeader-menu-item.isActive").position().left;

          self.$jQuery(".dvHeader-menu-fx").animate(
            {
              left: calcMenuUIPos+'px',
              width: calcMenuUIWidth+'px'
            }
          );

          self.$jQuery(".dvHeader-menu-fx").css("width", calcMenuUIWidth);
          self.$jQuery(".dvHeader-menu-fx").css("left", calcMenuUIPos);
        }, 500);
      }
    },
    computed: {
      ...mapGetters(["forUpdateDetails"]),
      ...mapGetters(["forSetPassword"])
    },
    methods: {
      checkSetPassword (){
        if(this.forUpdateDetails == 0 && this.forSetPassword == 1){
          // console.log(this.forUpdateDetails)
          // this.showModal('modal-update-details')
          const elem = document.getElementById('modal-set-password');
          const instance = M.Modal.init(elem, {dismissible: false});
          instance.open();
        }
      },
      updatePassword (){

      },
      checkUpdateDetails (){
        if(this.forUpdateDetails == 1){
          // console.log(this.forUpdateDetails)
          // this.showModal('modal-update-details')
          const elem = document.getElementById('modal-update-details');
          const instance = M.Modal.init(elem, {dismissible: false});
          instance.open();
        }
      },
      gotoMain () {
        if (this.$getConstRole('ROLE_SUB_ADMIN') == this.currentUserRole){
          this.$router.push({ name: 'admin_channels' })
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      },
      clickFile (){
        this.importFileName = ''
        this.referralfile = ''
        let referralfile = document.getElementById('referralfile');

        try {
          referralfile.value = null;
        } catch(ex) {
          console.log(ex)
        }
        if (referralfile.value) {
          referralfile.parentNode.replaceChild(referralfile.cloneNode(true), referralfile);
        }

        referralfile.click()
      },
      changePassword (){
        if(this.updateUserDetails){
          return false
        }

        let self = this
        self.updateUserDetails = true

        this.$http.secured.post('api/users/update-password', this.user)
          .then(response => {
            this.$store.commit('setForChangePassword', { stat: 0 })
            this.user.first_name = response.data.first_name
            this.user.last_name = response.data.last_name

            this.$store.commit('setFnameLname', { user: this.user })
            this.username = this.$store.getters.getCurrentUserMenuName
            this.user.current_password = ''
            this.user.new_password = ''
            this.user.confirm_new_password = ''

            this.closeModal('modal-change-password')
            this.closeModal('modal-set-password')
            this.showMessage('Your details have been successfully updated', 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(', '), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.updateUserDetails = false
          })
      },
      setYourPassword (){
        if(this.updateUserDetails){
          return false
        }

        let self = this
        self.updateUserDetails = true

        this.$http.secured.post('api/users/set-password', this.user)
          .then(response => {
            this.$store.commit('setForChangePassword', { stat: 0 })

            this.user.current_password = ''
            this.user.new_password = ''
            this.user.confirm_new_password = ''

            this.closeModal('modal-set-password')
            this.showMessage('Your password has been successfully updated', 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(', '), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.updateUserDetails = false
          })
      },
      updateUser (){
        if(this.updateUserDetails){
          return false
        }

        let self = this
        self.updateUserDetails = true

        this.$http.secured.post('api/users/update-details', this.user)
          .then(response => {
            this.$store.commit('setForUpdateDetails', { stat: 0 })

            this.user.first_name = response.data.first_name
            this.user.last_name = response.data.last_name

            this.$store.commit('setFnameLname', { user: this.user })
            this.username = this.$store.getters.getCurrentUserMenuName
            this.user.current_password = ''
            this.user.new_password = ''
            this.user.confirm_new_password = ''

            this.closeModal('modal-update-details')
            this.showMessage('Your details have been successfully updated', 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(', '), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.updateUserDetails = false
          })
      },
      doImportReferralData (){
        if(this.importFileName == ''){
          this.showMessage('Upload file is required.', 'sb-failed')
          return false
        }

        if(!this.dataPrivacy.isAgree){
          this.showMessage('Data privacy consent is required.', 'sb-failed')
          return false
        }

        this.referralfile = this.$refs.referralfile.files[0];
        this.importing = true

        let self = this

        let formData = new FormData();
        formData.append('file', this.referralfile);
        formData.append('is_agree_privacy_consent', this.dataPrivacy.isAgree);

        this.$http.secured.post('api/referrals/import-referral',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.showMessage(response.data.message, 'sb-success')
            this.closeModal('modal-import-referrals')

            this.$store.commit('refreshCntIncrement', { page: this.$route.name })
            // window.location.reload()
            // this.getChannels()
            // this.getDefaultData()
            // this.$emit('replacePhoto', response.data.photo)
          })
          .catch(error => {
            // this.showMessage(error.response.data, 'sb-failed')
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })

              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.importing = false
          })
      },
      onChangeFileUpload (){
        this.referralfile = this.$refs.referralfile.files[0];
        this.importFileName = ''
        if(this.referralfile){
          this.importFileName = this.referralfile.name
        }
      },
      showModal (str){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
        this.importFileName = ''
        this.referralfile = ''
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        this.channelName = ''
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      search (){

        if(this.q == ''){
          this.showMessage('The keyword field is required.', 'sb-failed')
          return false
        }

        this.$router.push({ name: 'search_results', params: { filter_by: 'clients'  } ,query: { q: this.q } })
      },
      manageNav (){
        // this.showMobileNav()
        // let self = this
        //
        // setTimeout(function(){
        //   self.$jQuery('.dvOverlayMenuItemFx').removeClass('menuFxActive')
        //   let activeMenu = self.$jQuery(".menuItemActive");
        //   let dvOverlayMenuItemFx = self.$jQuery(activeMenu).find('.dvOverlayMenuItemFx');
        //   self.$jQuery(dvOverlayMenuItemFx).addClass('menuFxActive')
        //   self.$jQuery(dvOverlayMenuItemFx).css('width', 0)
        //
        //   // let menuFxActive = document.querySelector(".menuFxActive")
        //
        //   // self.$jQuery(menuFxActive).animate(
        //   //   {
        //   //     width: '100%'
        //   //   }
        //   // )
        // }, 100);
      },
      showMobileNav (){
        var dvHamburger = document.querySelector(".dvHamburger");
        var dvOverlayMenu = document.querySelector(".dvOverlayMenu");
        var htmlOverflow = document.querySelector(".htmlOverflow");
        // var menuFxActive = document.querySelector(".menuFxActive");

        dvHamburger.classList.toggle("is-active");
        dvOverlayMenu.classList.toggle("ov-active");
        //** toggle for scrollbar (add globalOverflow class in html!) **
        htmlOverflow.classList.toggle("hide-overflow");

        this.$jQuery('.dvOverlayMenuItemFx').removeClass('menuFxActive')
        let activeMenu = this.$jQuery(".menuItemActive");
        let dvOverlayMenuItemFx = this.$jQuery(activeMenu).find('.dvOverlayMenuItemFx');
        this.$jQuery(dvOverlayMenuItemFx).addClass('menuFxActive')
        this.$jQuery(dvOverlayMenuItemFx).css('width', 0)

        let menuFxActive = document.querySelector(".menuFxActive")
        this.$jQuery(menuFxActive).animate(
          {
            width: '100%'
          }
        )

        // menuFxActive.classList.toggle("animateFx");
        // this.manageNav()
        // dvHamburger.addEventListener("click", function() {
        //
        // });
      },
      signout(){
        let el = this.$refs['tippy_settings'];
                if (el && el._tippy) {
                    el._tippy.hide()
                }
        this.$store.commit('unsetCurrentUser')
        window.location.href = '/signout'
        // this.$http.plain.get('signout')
        //   .then(response => {
        //     console.log(response);
        //     this.$store.commit('unsetCurrentUser')
        //     // this.$router.push({ name: 'signin' })
        //     window.location.href = '/dev.alisifirststep/login'
        //   })
        //   .catch(error => {
        //     console.log(error);
        //   })
      }
    },
    mounted() {

      if(!this.$store.state.signedIn){
        return ''
      }

      if(this.$route.name == 'search_results'){
        this.q = this.$route.query.q
      }

      if(this.$route.name == 'signin'){
        return
      }else{
        this.currentUserRole = this.$store.getters.getCurrentUserRole
        this.username = this.$store.getters.getCurrentUserMenuName
        this.currentUserPosition = this.$store.getters.getCurrentUserDetails.position

        this.user.first_name = this.$store.getters.getCurrentUserDetails.first_name
        this.user.last_name = this.$store.getters.getCurrentUserDetails.last_name
      }

      if(this.$route.name == 'search_results'){
        return
      }


      // if(this.$route.name == 'my_activity'){
      //   return
      // }
      // this.manageNav()

      let self = this

      setTimeout(function(){
        var calcMenuUIWidth = self.$jQuery(".dvHeader-menu-item.isActive").innerWidth();
        var calcMenuUIPos = self.$jQuery(".dvHeader-menu-item.isActive").position().left;

        self.$jQuery(".dvHeader-menu-fx").css("width", calcMenuUIWidth);
        self.$jQuery(".dvHeader-menu-fx").css("left", calcMenuUIPos);
      }, 500);

    },
    created () {
      let self = this
      setTimeout(function(){
        self.checkUpdateDetails()
        self.checkSetPassword()
      }, 500);
    },
    components: {
      SnackBar,
      DataPrivacyConsent
    }
  }



</script>
